"use client";

import { useEffect } from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { usePairedIntersectionObserver } from "@faire/retailer/hooks/ProductTileImpression/__internal__/ProductTileViewImpressionContext";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useUnmountProductTileContext } from "@faire/retailer/hooks/ProductTileImpression/__internal__/UnmountProductTileContext";

interface ITrackProductTileProps {
  ref: undefined | ((element: HTMLElement | null | undefined) => void);
  "data-collection-token": string;
  "data-brand-promo-token"?: string;
}

export const useCollectionTileViewImpression = ({
  collectionToken = "",
  brandPromoToken = "",
}: {
  collectionToken?: string;
  brandPromoToken?: string;
}): ITrackProductTileProps | undefined => {
  const handleIntersectionObserverCallbackRef = usePairedIntersectionObserver();
  const { onUnmount } = useUnmountProductTileContext();

  useEffect(() => {
    return () => {
      onUnmount(collectionToken, "");
    };
  }, [collectionToken, onUnmount]);

  return {
    ref: handleIntersectionObserverCallbackRef,
    "data-collection-token": collectionToken,
    "data-brand-promo-token": brandPromoToken,
  };
};
